import React, { useState } from "react"
import { Accordion, AccordionDetails, AccordionSummary, FormControl, Grid, InputLabel, MenuItem, Select, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"
import ErrorBoundary from "../../../../common/ErrorBoundary"
import { Box } from "@mui/system"
import useRtoPerformance from "./useRtoPerformance"
import { TableSkeleton } from "../../../../common/Skeletons"
import { formatNumber } from "../../../../helpers/UtilityHelper"
import SplitInLineChart from "./SplitInLineChart"
import PincodeAndCityWise from "./PincodeAndCityWise"
import RTOAnalysis from "./RtoAnalysis"
import ReasonAnalysis from "./ReasonAnalysis"
import CourierWiseSplit from "./CourierWiseSplit"
import DeliveryAttemptAnalysis from "./DeliveryAttemptAnalysis"
import RtoForwardDeliveryAnalysis from "./RtoForwardDeliveryAnalysis"
import CityWiseRto from "./CityWiseRto"
import PincodeMoMReport from "./PincodeMoMReport"
import InfoBox from "../../../../common/InfoBox"
import { useSelector } from "react-redux"

function RtoComponent() {

    const [calcOn, setCalcOn] = React.useState('DOD')
    const [shipType, setShipType] = useState("B2C")
    const { isLoading, data } = useRtoPerformance(calcOn, shipType)
    const { userInfo } = useSelector((state) => state.user)
    const handleChange = (event) => {
        setShipType(event.target.value);
    }
    return (
        <Accordion expanded>
            <AccordionSummary sx={{ boxShadow: 1, borderRadius: 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '0.9rem', fontWeight: 600 }}>RTO Performance</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {(userInfo?.merchant?.isD2CMerchant && userInfo?.merchant?.isPTLMerchant) &&
                                <FormControl variant="outlined" size="small" sx={{ minWidth: 100 }}>
                                    <InputLabel sx={{ fontSize: '0.7rem' }}>Shipment Type</InputLabel>
                                    <Select
                                        value={shipType}
                                        onChange={handleChange}
                                        label="Shipment Type"
                                        sx={{
                                            fontSize: '0.75rem',
                                            height: 30,
                                            '& .MuiSelect-select': { py: 0.5 },
                                        }}
                                    >
                                        <MenuItem value={"B2C"} sx={{ fontSize: '0.75rem' }}>B2C</MenuItem>
                                        <MenuItem value={"B2B"} sx={{ fontSize: '0.75rem' }}>B2B</MenuItem>
                                    </Select>
                                </FormControl>
                            }
                            <ToggleButtonGroup
                                color="primary"
                                value={calcOn}
                                exclusive
                                size="small"
                                onChange={(_e, v) => setCalcOn(v)}
                                sx={{
                                    '& .MuiToggleButton-root': {
                                        border: '1px solid',
                                    }
                                }}
                            >
                                <ToggleButton value="DOD">DoD</ToggleButton>
                                <ToggleButton value="WOW">WoW</ToggleButton>
                                <ToggleButton value="MOM">MoM</ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                    </Box>
                    <Typography sx={{ fontSize: '0.7rem', color: 'text.secondary', mt: 0.5 }}>
                        The data below provides analysis on the rto related aspects. All data is populated on basis of the date of shipment creation in Proship.
                    </Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: '#f5f8fa', px: 0 }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                        {isLoading && <TableSkeleton rows={10} />}
                        {!isLoading && (
                            <Grid container spacing={2}>
                                <Grid item xs={3}>
                                    <InfoBox header="Total Shipments" value={formatNumber(data?.awbRegisteredOrderCount)} />
                                </Grid>
                                <Grid item xs={3}>
                                    <InfoBox header="RTO" value={formatNumber(data?.rtoCount)} />
                                </Grid>
                                <Grid item xs={3}>
                                    <InfoBox header="RTO %" value={`${data?.overallRtoPercentage ?? 0}`} />
                                </Grid>
                                <Grid item xs={3}>
                                    <InfoBox header="Avg Delivery Attempts" value={data?.avgDeliveryAttemptCount ?? 0} />
                                </Grid>
                                <Grid item xs={12}>
                                    <SplitInLineChart data={data?.lineChartData || []} />
                                </Grid>
                                <Grid item xs={12}>
                                    <ReasonAnalysis data={data?.lineChartData || []} />
                                </Grid>
                                <Grid item xs={12}>
                                    <PincodeAndCityWise data={data} />
                                </Grid>
                                <Grid item xs={12}>
                                    <RTOAnalysis data={data?.lineChartData || []} />
                                </Grid>
                                <Grid item xs={12}>
                                    <CourierWiseSplit data={data?.lineChartData || []} courierIds={data?.uniqCourierIds || []} />
                                </Grid>
                                <Grid item xs={12}>
                                    <DeliveryAttemptAnalysis data={data?.courierWiseDeliveryAttemptAgeing || []} />
                                </Grid>
                                <Grid item xs={12}>
                                    <RtoForwardDeliveryAnalysis data={data?.firstForwardDeliveryAttemptSLA || []} />
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <CityWiseRto data={data?.lineChartData || []} deliveryCities={data?.deliveryCities || []} />
                                </Grid> */}
                                <Grid item xs={12}>
                                    <PincodeMoMReport allRtoData={data?.allRtoData || []} />
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default function RtoSummary() {
    return (
        <ErrorBoundary>
            <RtoComponent />
        </ErrorBoundary>
    )
}